module.exports = __webpack_public_path__ + "img/d.d8c030b6.svg";